import React, { Component } from 'react';
import { TabPane } from 'reactstrap';
import { CollapsibleCard } from '../shared/CollapsibleCard';
import { PersonalInfoItem } from './PersonalInfoItem';
import { DateUtils } from '../DateUtils'

export class PersonalInformation extends Component {
  constructor(props) {
      super(props);
      this.dateUtils = new DateUtils();
    this.state = {
      employee: {}
    };
    this.buildAddress = this.buildAddress.bind(this);
  }

  buildAddress(address) {
    var streetAddress = (address || '').streetAddress;
    var city = (address || '').city;
    var state = (address || '').state;
    var zipCode = ((address || '').zipCode || '').slice(0, 5);
      if (this.isNullOrWhitespace(streetAddress)) return 'Not Provided';
    return (<section>{streetAddress}<br />{city}, {state} {zipCode}</section>);
  }

  isNullOrWhitespace(input) {
    if (input === undefined || input === null) return true;
    return input.replace(/\s/g, '').length < 1;
  }

  formatPhoneNumber(numberObj) {
    if(numberObj === null || numberObj === undefined || this.isNullOrWhitespace(numberObj.number))
      return 'Not Provided';
    return ('(' + numberObj.areaCode + ') ' + numberObj.number.slice(0, 3) + '-' + numberObj.number.slice(3, 7));
  }

  formatMaritalStatus(status) {
    if (status === 'M') return 'Married';
    if (status === 'S') return 'Single';
    return 'Not Provided';
    }

    formatRelationship(relation) {
        if (this.isNullOrWhitespace(relation))
            return "Not Provided"
        else
            return relation;
    }

  formatGender(gender) {
    if (gender === 'M') return 'Male';
    if (gender === 'F') return 'Female';
    if (gender === 'N') return 'Nonbinary';
    return 'Not Provided';
    }

  formatContactName(contact) {
    var coalescedContact = (contact || {})
    if ((coalescedContact.firstName === null || this.isNullOrWhitespace(coalescedContact.firstName))
      && (coalescedContact.lastName === null || this.isNullOrWhitespace(coalescedContact.lastName)))
      return 'Not Provided';
    return (coalescedContact.firstName || '') + ' ' + (coalescedContact.lastName || '');
  }

  render() {
    return (
      <TabPane tabId="2">
        <CollapsibleCard title='Personal Information'>
            <PersonalInfoItem title="Name">
                <employee-name>
                    {this.props.employee.firstName} {this.props.employee.middleInitial} {this.props.employee.lastName}
                </employee-name>
            </PersonalInfoItem>
            <PersonalInfoItem title="Mailing Address">
                {this.buildAddress(this.props.employee.mailingAddress)}
            </PersonalInfoItem>
          <PersonalInfoItem title="Physical Address">
            {this.buildAddress(this.props.employee.physicalAddress)}
          </PersonalInfoItem>
          <PersonalInfoItem title="Phone">
            <table>
              <tbody>
                <tr><td>Home:</td><td className="phone-table-data">{this.formatPhoneNumber(this.props.employee.homePhone)}</td></tr>
                <tr><td>Work:</td><td className="phone-table-data">{this.formatPhoneNumber(this.props.employee.workPhone)}</td></tr>
                <tr><td>Cell:</td><td className="phone-table-data">{this.formatPhoneNumber(this.props.employee.cellPhone)}</td></tr>
              </tbody>
            </table>
          </PersonalInfoItem>
          <PersonalInfoItem title="Date of Birth">
            {this.dateUtils.formatDateFriendly(this.props.employee.birthDate, 'MMMM dd, yyyy')}
          </PersonalInfoItem>
          <PersonalInfoItem title="Social Security #">
            {this.props.employee.maskedSocial}
          </PersonalInfoItem>
          <PersonalInfoItem title="Ethnicity">
            {this.props.employee.ethnicCodeName}
          </PersonalInfoItem>
          <PersonalInfoItem title="Marital Status">
            {this.formatMaritalStatus(this.props.employee.maritalStatus)}
          </PersonalInfoItem>
          <PersonalInfoItem title="Gender">
            {this.formatGender(this.props.employee.gender)}
          </PersonalInfoItem>
          <PersonalInfoItem title="Bilingual Language">
            {this.props.employee.secondaryLanguage}
          </PersonalInfoItem>
        </CollapsibleCard>
        <CollapsibleCard title='Emergency Contacts'>
          <h6>Primary</h6>
          <PersonalInfoItem title="Name">
            {this.formatContactName(this.props.employee.primaryContact)}
          </PersonalInfoItem>
          <PersonalInfoItem title="Relationship">
            {this.formatRelationship((this.props.employee.primaryContact || {}).relationship)}
          </PersonalInfoItem>
          <PersonalInfoItem title="Address">
            {this.buildAddress((this.props.employee.primaryContact || {}).address)}
          </PersonalInfoItem>
          <PersonalInfoItem title="Phones">
            <table>
              <tbody>
                <tr><td>Home:</td><td className="phone-table-data">{this.formatPhoneNumber((this.props.employee.primaryContact || {}).homePhone)}</td></tr>
                <tr><td>Work:</td><td className="phone-table-data">{this.formatPhoneNumber((this.props.employee.primaryContact || {}).workPhone)}</td></tr>
                <tr><td>Cell:</td><td className="phone-table-data">{this.formatPhoneNumber((this.props.employee.primaryContact || {}).cellPhone)}</td></tr>
              </tbody>
            </table>
            </PersonalInfoItem>
            <hr/>
          <h6>Secondary</h6>
          <PersonalInfoItem title="Name">
            {this.formatContactName(this.props.employee.secondaryContact)}
          </PersonalInfoItem>
          <PersonalInfoItem title="Relationship">
            {this.formatRelationship((this.props.employee.secondaryContact || {}).relationship)}
          </PersonalInfoItem>
          <PersonalInfoItem title="Address">
            {this.buildAddress((this.props.employee.secondaryContact || {}).address)}
          </PersonalInfoItem>
          <PersonalInfoItem title="Phones">
            <table>
              <tbody>
                <tr><td>Home:</td><td className="phone-table-data">{this.formatPhoneNumber((this.props.employee.secondaryContact || {}).homePhone)}</td></tr>
                <tr><td>Work:</td><td className="phone-table-data">{this.formatPhoneNumber((this.props.employee.secondaryContact || {}).workPhone)}</td></tr>
                <tr><td>Cell:</td><td className="phone-table-data">{this.formatPhoneNumber((this.props.employee.secondaryContact || {}).cellPhone)}</td></tr>
              </tbody>
            </table>
          </PersonalInfoItem>
        </CollapsibleCard>
      </TabPane>
    );
  }
}